// ================================================
// 接口地址统一配置文件
// 切换环境：只需要改下面的 devBaseURL，
// src/request 下的 http.js / httpNew.js / https.js / https2.js 会自动同步生效
// ================================================

// 开发环境 - 文龙
const devBaseURL = 'http://dfrt.natapp4.cc'
// 开发环境 - 黄彬
// const devBaseURL = 'http://wxgzhapp.natapp1.cc'

// 生产环境
const prodBaseURL = 'https://wxappvue.df01.top/api'

// 判断是否是开发环境
export const baseURL = process.env.NODE_ENV === 'development' ? devBaseURL : prodBaseURL
